module.exports = __webpack_public_path__ + "static/images/empty-backpack2.be5dca0.png";